import {
  AccountType,
  Roles,
} from '@/autogenerated/@prisma/prisma-mongo-client';
import { DialogKey } from '@/components/features/dialogs/infra/context/DialogContext';
import { IconName } from '@/components/ui/Icon';

export type MenuTitle =
  | 'home'
  | 'discover'
  | 'messages'
  | 'profile'
  | 'languageProgram'
  | 'manageAccount'
  | 'contactHaven'
  | 'helpCenter'
  | 'logout'
  | 'accountSettings'
  | 'privacyPolicy'
  | 'accounts'
  | 'security'
  | 'matches'
  | 'admin'
  | 'hlp'
  | 'teachers'
  | 'tracker'
  | 'recommendationEmail'
  | 'appSettings'
  | 'notifications';

export type MenuItemType = {
  title: MenuTitle;
  icon: IconName;
  link?: string;
  dialogKey?: DialogKey;
  shownOnlyForAccountType?: AccountType;
  showOnlyForRole?: Roles;
  color?: string;
};

export const getMenuItems = (
  accountType: AccountType | undefined,
  roles: Roles[] | undefined
): MenuItemType[] => {
  return [
    {
      title: 'home' as const,
      icon: IconName.Dashboard,
      link: '/dashboard',
      shownOnlyForAccountType: AccountType.Refugee,
    },
    {
      title: 'discover' as const,
      icon: IconName.Search,
      link: '/discover',
    },
    {
      title: 'messages' as const,
      icon: IconName.MyChatOff,
      link: '/inbox',
    },
    {
      title: 'profile' as const,
      icon: IconName.Profile,
      link: '/edit-profile',
    },
    {
      title: 'languageProgram' as const,
      icon: IconName.Language,
      link: '/language-program',
      shownOnlyForAccountType: AccountType.Refugee,
    },
    {
      title: 'teachers' as const,
      icon: IconName.Language,
      link: '/teachers',
      shownOnlyForRole: Roles.Teacher,
    },
  ].filter(
    (item) =>
      (!item?.shownOnlyForAccountType ||
        item.shownOnlyForAccountType === accountType) &&
      (!item?.shownOnlyForRole ||
        (roles && roles.includes(item.shownOnlyForRole)))
  );
};

export const settingsItems: MenuItemType[] = [
  {
    title: 'manageAccount' as const,
    icon: IconName.Pencil,
    link: '/account-settings',
  },
  {
    title: 'notifications' as const,
    icon: IconName.Notification,
    link: '/notifications',
  },
  {
    title: 'contactHaven' as const,
    icon: IconName.Contact,
    dialogKey: 'contact-haven',
  },
  {
    title: 'helpCenter' as const,
    icon: IconName.Help,
    link: 'https://haven-user-support.gorgias.help/en-US',
  },
  {
    title: 'logout' as const,
    icon: IconName.Logout,
    link: '/logout',
    color: 'destructive-400',
  },
] as const;

export const privacyPolicyItems: MenuItemType[] = [
  {
    title: 'privacyPolicy' as const,
    icon: IconName.File,
    link: 'https://www.findhaven.org/privacy-policy-user-agreement',
  },
];

export const adminMenuItems: MenuItemType[] = [
  {
    title: 'accounts' as const,
    icon: IconName.Profile,
    link: '/admin/accounts',
  },
  {
    title: 'security' as const,
    icon: IconName.CheckInCircle,
    link: '/admin/security',
  },
  {
    title: 'matches' as const,
    icon: IconName.Community,
    link: '/admin/matches',
  },
  {
    title: 'hlp' as const,
    icon: IconName.Book,
    link: '/hlp-admin',
  },
  {
    title: 'tracker' as const,
    icon: IconName.Archive,
    link: '/admin/tracker',
  },
  {
    title: 'recommendationEmail' as const,
    icon: IconName.File,
    link: '/admin/recommendation-email',
  },
  {
    title: 'appSettings' as const,
    icon: IconName.Settings,
    link: '/admin/app-settings',
  },
];
